export const ON_PREM_NODE_TYPE_MAP = Object.freeze({
  CONTROLLER: 'INFERENCE_CONTROLLER',
  WORKER: 'INFERENCE_WORKER',
})

export const ON_PREM_NODE_TYPE_OPTIONS = Object.freeze([
  "INFERENCE_CONTROLLER",
  "INFERENCE_WORKER"
])